import type { TabelaCondicaoResponse, VincularCondicaoDto } from '@triade/contracts';
import { useConsulta, useMutacao } from './base';

export function useTabelaCondicoes(tabelaId: string | undefined) {
  return useConsulta<TabelaCondicaoResponse[]>(
    ['tabelas-preco', tabelaId, 'condicoes'],
    `/tabelas-preco/${tabelaId}/condicoes`,
    { ativo: !!tabelaId },
  );
}

export function useVincularCondicao() {
  return useMutacao<TabelaCondicaoResponse, { tabelaId: string } & VincularCondicaoDto>({
    metodo: 'POST',
    caminho: (v) => `/tabelas-preco/${v.tabelaId}/condicoes`,
    corpo: ({ tabelaId: _t, ...resto }) => resto,
    invalidar: [['tabelas-preco']],
  });
}

/** Marca ou desmarca a condicao padrao da vigencia em aberto (X8: so condicao ligada). `tabela.editar`. */
export function useMarcarPadraoCondicao() {
  return useMutacao<TabelaCondicaoResponse, { tabelaId: string; condicaoId: string; isDefault: boolean }>({
    metodo: 'PATCH',
    caminho: (v) => `/tabelas-preco/${v.tabelaId}/condicoes/${v.condicaoId}`,
    corpo: ({ isDefault }) => ({ isDefault }),
    invalidar: [['tabelas-preco']],
  });
}

/** Remove a condicao da vigencia em aberto (204). `tabela.editar`. */
export function useDesvincularCondicao() {
  return useMutacao<void, { tabelaId: string; condicaoId: string }>({
    metodo: 'DELETE',
    caminho: (v) => `/tabelas-preco/${v.tabelaId}/condicoes/${v.condicaoId}`,
    invalidar: [['tabelas-preco']],
  });
}
